import { ColorPicker, Upload, Typography, Modal, Row, Col, Button, Popover, DatePicker, Card, Input, Popconfirm, Checkbox } from 'antd';
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { ExclamationCircleFilled, PlusOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import axios from 'axios';
import AdminModal from "./AdminModal";
const { Title, Paragraph, Text, Link } = Typography;
const { TextArea } = Input;
const { confirm } = Modal;
const TeacherModal = (props) => {
    const [check, setCheck] = useState(false);
    const [schedule_date, set_schedule_date] = useState(undefined);
    const [blog_id, set_blog_id] = useState(null);
    useEffect(() => {
        // console.log(props.editcard);
        setCheck(false);
        if (props.editcard['annoucement_time'] != undefined) {
            setCheck(true)
            set_schedule_date(props.editcard['annoucement_time']);
            // console.log(1)
        } else {
            set_schedule_date(null);
        }
        if (JSON.stringify(props.editcard) != '{}') {
            set_blog_id(props.editcard.blog_id);
        } else {
            props.setEditCard({ file_id: [], file_url: [] });
            set_blog_id('');
        }
    }, [props.editcard])
    return (
        <>
            <AdminModal
                {...props}
                title={(<>
                    <Col style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 53, left: 32 }} >{props.title}</Col>
                    <Col>
                        {props.edit ?
                            <>
                                <Popconfirm
                                    placement="topRight"
                                    title='確定刪除嗎？'
                                    onConfirm={e => props.handleDelete(props.editcard['blog_id'])}
                                    okText="確定"
                                    cancelText="取消"
                                >
                                    <Button style={{ backgroundColor: '#FCF5F6' }} >
                                        <Row>
                                            <Col span={6}>
                                                <img width="80%" src='/cram_school/trashicon.png'></img>
                                            </Col>
                                            <Col span={18}>
                                                <span>刪除貼文</span>
                                            </Col>
                                        </Row>
                                    </Button>
                                </Popconfirm>
                            </> :
                            <>
                            </>
                        }
                    </Col>
                </>)}
                uploads
            >
                <Row gutter={[8, 8]} align={'middle'}>
                    <Col span={6}>姓名</Col>
                    <Col span={18}>
                    <Input style={{ width: 180 }} placeholder={'請輸入教師姓名(必填)'} type='text' value={props.editcard.teacher_name} name="teacher_name" onChange={e => props.setEditCard(prev => ({ ...prev, teacher_name: e.target.value }))} />
                    </Col>
                    <Col span={6}>任教系所(單位)</Col>
                    <Col span={18}>
                    <Input style={{ width: 180 }} placeholder={'請輸入教師任教系所(單位)（必填)'} type='text' value={props.editcard.teacher_expertise} name="teacher_expertise" onChange={e => props.setEditCard(prev => ({ ...prev, teacher_expertise: e.target.value }))} />
                    </Col>
                    <Col span={6}>聯絡電話</Col>
                    <Col span={18}>
                    <Input style={{ width: 180 }} placeholder={'請輸入教師電話(必填)'} type='text' value={props.editcard.teacher_phone} name="teacher_phone" onChange={e => props.setEditCard(prev => ({ ...prev, teacher_phone: e.target.value }))} />
                    </Col>
                    <Col span={6}>老師電子信箱</Col>
                    <Col span={18}>
                        <Input placeholder={'請輸入老師電子信箱'} type='email' value={props.editcard && props.editcard.email} name="email" onChange={e => props.setEditCard(pre => ({ ...pre, email: e.target.value }))} />
                    </Col>
                    <Col span={6}>手機</Col>
                    <Col span={18}>
                    <Input style={{ width: 180 }} placeholder={'請輸入教師手機'} type='text' value={props.editcard.teacher_cellphone} name="teacher_cellphone" onChange={e => props.setEditCard(prev => ({ ...prev, teacher_cellphone: e.target.value }))} />
                    </Col>
                    {/* <Col span={6}>貼文名稱</Col>
                    <Col span={18}>
                        <Input placeholder={'請輸入貼文名稱'} type='text' value={props.editcard && props.editcard['title']} name="name"
                            onChange={e => props.setEditCard(prev => {
                                return (
                                    {
                                        ...prev,
                                        title: e.target.value,
                                    }
                                )
                            })}
                            autoComplete="off" />
                    </Col>
                    <Col span={6}>老師姓名</Col>
                    <Col span={18}>
                        <label>{props.editcard['teacher_name']}</label>
                    </Col>
                    <Col span={6}>老師專長</Col>
                    <Col span={18}>
                        <Input placeholder={'請輸入老師專長'} type='text' value={props.editcard && props.editcard['expersite']} name="expersite"
                            onChange={e => props.setEditCard(prev => {
                                return (
                                    {
                                        ...prev,
                                        expersite: e.target.value,
                                    }
                                )
                            })} />
                    </Col> */}
                    {/* <Col span={6}>老師電話</Col>
                    <Col span={18}>
                        <Input placeholder={'請輸入老師電話'} type='text' value={props.editcard && props.editcard['phone']} name="expersite"
                            onChange={e => props.setEditCard(prev => {
                                return (
                                    {
                                        ...prev,
                                        phone: e.target.value,
                                    }
                                )
                            })} />
                    </Col>
                    <Col span={6}>老師電子信箱</Col>
                    <Col span={18}>
                        <Input placeholder={'請輸入老師電子信箱'} type='email' value={props.editcard && props.editcard.email} name="email" onChange={e => props.setEditCard(pre => ({ ...pre, email: e.target.value }))} />
                    </Col> */}
                    {/* <Col span={6}>老師地址</Col> */}
                    {/* <Col span={18}> */}
                        {/* <Input placeholder={'請輸入老師地址'} type='text' value={props.editcard['address']} name="expersite"
                            onChange={e => props.setEditCard(prev => {
                                return (
                                    {
                                        ...prev,
                                        address: e.target.value,
                                    }
                                )
                            })} /> */}
                        {/* <label>{props.editcard && props.editcard['address']}</label> */}
                    {/* </Col> */}
                    {/* <Col span={6}>老師入職時間</Col> */}
                    {/* <Col span={18}> */}
                        {/* <DatePicker style={{ width: '100%' }}
                            format={'YYYY-MM-DD'}
                            value={props.editcard['employment_time_start'] != null ? dayjs(props.editcard['employment_time_start'], 'YYYY-MM-DD') : null}
                            onChange={(value, dateString) => props.setEditCard(preState => {
                                return (
                                    {
                                        ...preState,
                                        'employment_time_start': dateString,
                                    }
                                )
                            })}
                        /> */}
                        {/* <label>{props.editcard && props.editcard['employment_time_start']}</label> */}
                    {/* </Col> */}
                    {/* <Col span={6}>老師離職時間</Col> */}
                    {/* <Col span={18}> */}
                        {/* <DatePicker style={{ width: '100%' }}
                            format={'YYYY-MM-DD'}
                            value={props.editcard['employment_time_end'] != null ? dayjs(props.editcard['employment_time_end'], 'YYYY-MM-DD') : null}
                            onChange={(value, dateString) => props.setEditCard(preState => {
                                return (
                                    {
                                        ...preState,
                                        'employment_time_end': dateString,
                                    }
                                )
                            })}
                        /> */}
                        {/* <label>{props.editcard && props.editcard['employment_time_end']}</label> */}
                    {/* </Col> */}
                    <Col span={6}>備註</Col>
                    <Col span={18}>
                        <label>{props.editcard && props.editcard['note']}</label>
                    </Col>
                    <Col span={6}></Col>
                    {/* <Col span={18}>
                        <Checkbox checked={check} onChange={e => setCheck(!check)}>排程發佈</Checkbox>
                        {check || props.editcard['annoucement_time'] != undefined ?
                            <DatePicker
                                // value={props.editcard['annoucement_time'] != undefined ? dayjs(null) : dayjs(schedule_date, 'YYYY-MM-DD')}
                                value={schedule_date != '' && schedule_date != undefined && schedule_date != null ? dayjs(schedule_date, 'YYYY-MM-DD') : null}
                                onChange={(date, dateString) => props.setEditCard(prev => {
                                    return (
                                        {
                                            ...prev,
                                            annoucement_time: dateString,
                                        }
                                    )
                                })} />
                            : null
                        }
                    </Col> */}
                    {/* <Col span={6}>內文說明</Col>
                    <Col span={18}>
                        <TextArea rows={4} type='text' value={props.editcard && props.editcard['content']} name="expersite" placeholder="請輸入老師介紹或個人名言"
                            onChange={e => props.setEditCard(prev => {
                                return (
                                    {
                                        ...prev,
                                        content: e.target.value,
                                    }
                                )
                            })} />
                    </Col> */}
                    {/* <Col span={6}>顏色</Col>
                    <Col span={18}>
                        <ColorPicker
                            format={'hex'}
                            value={props.editcard.background_color}
                            onChange={color =>
                                props.setEditCard((pre) => {
                                    return (
                                        {
                                            ...pre,
                                            background_color: `#${color.metaColor.toHex()}`,
                                        }
                                    )
                                })
                            }></ColorPicker>
                    </Col> */}
                    {/* <Col span={6}>文字顏色</Col>
                    <Col span={18}>
                        <ColorPicker
                            format={'hex'}
                            value={props.editcard.font_color}
                            onChange={color =>
                                props.setEditCard((pre) => {
                                    return (
                                        {
                                            ...pre,
                                            font_color: `#${color.metaColor.toHex()}`,
                                        }
                                    )
                                })
                            }></ColorPicker>
                    </Col> */}
                    {/* <Col span={8}>照片背景顏色</Col>
                    <Col span={16}>
                        <ColorPicker
                            format={'hex'}
                            value={props.editcard.pic_background_color}
                            onChange={color =>
                                props.setEditCard((pre) => {
                                    return (
                                        {
                                            ...pre,
                                            pic_background_color: `#${color.metaColor.toHex()}`,
                                        }
                                    )
                                })
                            }></ColorPicker>
                    </Col> */}
                </Row>
            </AdminModal >
        </>
    )

}
export default TeacherModal;